// USER_KEY = auth token

export async function getToken(key) {
  return localStorage.getItem(key);
}

export async function setToken(key, value) {
  return localStorage.setItem(key, value);
}
